export default __webpack_public_path__ + "static/media/banner-tips-bg.847d6165.jpg";